import React from "react"
import {Button, Icon} from "antd"


const SubmitUSStatesButtonText = ({userHasNotChosenAnyUSStatesYet, localSelectionDiffersFromReduxStateSelection, initialLoadOfMapHasCompleted}) => {
	if (!initialLoadOfMapHasCompleted) return 'Loading map...'
	if (userHasNotChosenAnyUSStatesYet) return 'Choose states to explore below'
	if (!localSelectionDiffersFromReduxStateSelection) return 'Nothing has changed'
	
	return (
		<span>
			<Icon type="play-circle" />{` Go!`}
		</span>
	)
}


export default React.memo(
	({onClick, userHasNotChosenAnyUSStatesYet, localSelectionDiffersFromReduxStateSelection, initialLoadOfMapHasCompleted}) => {
		const invalidSubmission = userHasNotChosenAnyUSStatesYet || !localSelectionDiffersFromReduxStateSelection
		return (
			<div className={`enter-map-button ${invalidSubmission ? '' : 'ready-to-start'}`}>
				<Button
					loading={!initialLoadOfMapHasCompleted}
					disabled={invalidSubmission}
					onClick={onClick}
					size={invalidSubmission ? "small" : "large"}
					type={invalidSubmission ? 'dashed' : 'primary'}
				>
					<SubmitUSStatesButtonText
						userHasNotChosenAnyUSStatesYet={userHasNotChosenAnyUSStatesYet}
						localSelectionDiffersFromReduxStateSelection={localSelectionDiffersFromReduxStateSelection}
						initialLoadOfMapHasCompleted={initialLoadOfMapHasCompleted}
					/>
				</Button>
			</div>
		)
	}
)
